import { LineDrawingManager } from "./lineDrawing";

export const startDrawingManager = (map: google.maps.Map, strokeColor: string) => {
    const drawingManager = new LineDrawingManager({
        drawingMode: "polyline",
        drawingControl: false,
        map: map,
        polylineOptions: {
            strokeColor: strokeColor, // ライン色(#RRGGBB形式)
            strokeOpacity: 1, // ライン透明度 0.0～1.0(デフォルト)
            strokeWeight: 2, // ライン太さ(単位ピクセル)
            editable: true,
        },
    });

    return drawingManager;
}

export const endDrawingManager = (drawingManager: LineDrawingManager) => {
    drawingManager.setDrawingMode(null)
}
